import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { routerReducer as routing } from 'react-router-redux';
import alerts from './alerts';
import catalogues from './catalogues';
import dashboard from '../../Dashboard/reducer';
import dialogs from './dialogs';
import tables from './tables';
import technicians from '../../TechniciansReportForm/reducer';
import user from './user';

const rootReducer = combineReducers({
  alerts,
  catalogues,
  dashboard,
  dialogs,
  form,
  routing,
  tables,
  technicians,
  user
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/index.js